// extracted by mini-css-extract-plugin
module.exports = {"head":"header_head__2ohyT","h1":"header_h1__2MckZ","nameTH":"header_nameTH__1tAOK","nameEng":"header_nameEng__2Atjy"};